import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { publicBaseQuery, tagTypes } from './utils'
import { ContentPageType, GetCampaignContentResponse } from './customer.types'

export interface GetCampaignDetailsArgs {
  programme_slug: string
  campaign_code: string
}

export interface GetCampaignContentArgs extends GetCampaignDetailsArgs {
  page_type: ContentPageType
  language: string
}

export interface GetCampaignDetailsResponse {
  campaign_name: string
  start_date: string
  end_date: string
  language_config: {
    default: string
    available: string[]
  }
}

export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery(publicBaseQuery),
  tagTypes,
  endpoints: builder => ({
    // Get campaign details
    getCampaignDetails: builder.query<GetCampaignDetailsResponse, GetCampaignDetailsArgs>({
      query: ({ programme_slug, campaign_code }) => `/v1/trade-in/campaign/${programme_slug}/${campaign_code}`,
    }),
    // Get campaign content
    getCampaignContent: builder.query<GetCampaignContentResponse, GetCampaignContentArgs>({
      query: ({ programme_slug, campaign_code, page_type, language }) =>
        `/v1/trade-in/campaign/${programme_slug}/${campaign_code}/content/${page_type}?lang=${language}`,
    }),
  }),
})
